<template>
	<ul role="list" class="divide-y divide-gray-100">
    <li v-for="doc in docs" :key="doc.id" class="flex justify-between gap-x-6 py-5">
      <div class="flex min-w-0 gap-x-4">
        <div class="min-w-0 flex-auto">
          <p class="text-sm/6 font-semibold text-gray-900">{{ doc.tipo_documento }}</p>
          <p class="mt-1 truncate text-xs/5 text-gray-500">{{ doc.nome_arquivo }}</p>
        </div>
      </div>
      <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
        <p class="text-sm/6 text-gray-900">Foi criado em, <time :datetime="doc.created_at">{{ doc.created_at }}</time></p>
        <p class="mt-1 text-xs/5 text-gray-500">
          <a target="_blank" :href="doc.link"> Visualizar</a>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>

	export default {
		name: 'PropostaDocumentosPersonalizados',
		async created(){},
		props: {
			docs:{
				type:Array,
				required:true
			}
		},  
		watch: {
			
		}, 
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		components:{
		},
	}
</script>